<div class="card">
  <div class="card-header">
    <h3 class="text-brand my-3">
      {{ rendering() | scFieldValue: 'TitleText' }}
    </h3>
    <h5>
      {{ rendering() | scFieldValue: 'SubtitleText' }}
    </h5>
  </div>
  <div class="card-body">
    <form
      [formGroup]="form()"
      (ngSubmit)="formSubmit.emit()"
      [wlTrackStep]="trackStep()"
    >
      <rfa-radio-group [control]="form().controls.title" />

      <rfa-name [form]="form().controls.name" />

      <rfa-text-input [control]="form().controls.phone" />
      <rfa-text-input [control]="form().controls.email" />
      <rfa-text-area [control]="form().controls.remarks" />

      <rfa-label [label]="rendering().fields.ConditionLabel.value" />
      <rfa-checkbox [control]="form().controls.allowDataUsage" />

      <rfa-label
        [label]="rendering().fields.PromotionsLabel.value"
        [showOptional]="true"
      />
      <rfa-checkbox [control]="form().controls.allowPromotionalUpdates" />

      <rfa-submit
        [submitState]="submitState()"
        wlAutomationId="homebattery-advice--submit-button"
      >
        {{ rendering() | scFieldValue: 'SubmitButtonText' }}
      </rfa-submit>
      @if (submitState().status === 'ERROR') {
        <rfa-submit-error />
      }
    </form>
  </div>
</div>
